import { render, staticRenderFns } from "./RiderAssign.vue?vue&type=template&id=05bdd5c4&"
import script from "./RiderAssign.vue?vue&type=script&lang=js&"
export * from "./RiderAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports